module.exports = __webpack_public_path__ + "static/media/15.4c30d26a.png";